import { Immutable } from "immer";
import React from "react";
import { setFocusedStore } from "tsi-common-react/src/apps/retail/reducers";
import {
    filteredStoreSelector,
    focusedStoreIDSelector,
} from "tsi-common-react/src/apps/retail/selectors";
import { RetailStore } from "tsi-common-react/src/models/location";
import { preferredLocationSelector } from "tsi-common-react/src/store/common/selectors";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { formatPhoneNumber } from "tsi-common-react/src/utils/format";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { RetailLocatorBlock } from "./RetailLocatorContent";

export const RetailLocator = (): React.ReactNode => {
    const location = useAppSelector(preferredLocationSelector);
    const stores = useAppSelector(filteredStoreSelector);
    const focusedStoreID = useAppSelector(focusedStoreIDSelector);
    const dispatch = useAppDispatch();

    const onBeforeInfoWindowOpen = (
        info: google.maps.InfoWindow,
        store: Immutable<RetailStore>,
    ) => {
        dispatch(setFocusedStore({ externalID: store.external_id }));
        // TODO(i18n): HTML template string building InfoWindow content needs to use t tagged templates for any static text, and the address format should be internationalized to support different country formats
        const content = `
            <h5>${store.name}</h5>
            <p>${store.address}</p>
            <p>${store.city}, ${store.state} ${store.postal}</p>
            <p>${store.phone ? formatPhoneNumber(store.phone) : ""}</p>
        `;
        info.setContent(content);
    };

    const onInfoWindowClose = () => {
        dispatch(setFocusedStore({ externalID: null }));
        const document = getDocument();
        const locationsList = document?.querySelector("div.locations");
        if (locationsList) {
            locationsList.scrollTop = 0;
        }
    };

    return (
        <RetailLocatorBlock
            location={location}
            stores={stores}
            focusedStoreID={focusedStoreID}
            onBeforeInfoWindowOpen={onBeforeInfoWindowOpen}
            onInfoWindowClose={onInfoWindowClose}
        />
    );
};
